import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/kyle")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Kyle, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Kyle & Hays County. Free quotes — +1 (830) 390-9588.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Kyle, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Kyle and Hays County.",
      keywords: "awnings Kyle, awning company Kyle, custom awnings Kyle, sail shades Kyle, patio covers Kyle, pergola covers Kyle, metal awnings Kyle, canvas awnings Kyle, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Kyle", "Hays County"),
  }),
  component: () => <CityHomePage city="Kyle" region="Hays County" />,
});
